import socket from './socket';

/* Actions */

const getDailyReports = (currentDay, interval, headers) =>
  socket.get(`/analogs/dailyreport/${currentDay}/${interval.current}`, undefined, headers);

const getMonthlyReports = (currentMonth, headers) =>
  socket.get(`/analogs/monthlyreport/${currentMonth}`, undefined, headers);
const getYearlyReports = (currentYear, headers) =>
  socket.get(`/analogs/yearlyreport/${currentYear}`, undefined, headers);

export default {
  getDailyReports,
  getMonthlyReports,
  getYearlyReports,
};
